import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { useLogEvent } from '~/hooks/useLogEvent'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useDeleteCustomerAttributeGroupMutation } from '../hooks/useDeleteCustomerAttributeGroupMutation'

export const DeleteCustomerAttributeGroupDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { customerAttributeGroup } = dialogInfo

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const logEvent = useLogEvent()
  const deleteCustomerAttributeGroupMutation =
    useDeleteCustomerAttributeGroupMutation({
      onSuccess: (data) => {
        // グループ内の顧客属性が他から参照されている場合などdeleteCustomerAttributeGroupはresult: falseを返す。削除できていないので記録しない。
        if (data.deleteCustomerAttributeGroup?.result) {
          logEvent('Delete customer attribute group')
        }
        closeDialogWithRefresh()
      },
    })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    deleteCustomerAttributeGroupMutation.mutate(customerAttributeGroup.id)
  }, [deleteCustomerAttributeGroupMutation, customerAttributeGroup.id])

  return (
    <ExecuteCancelDialog
      executing={deleteCustomerAttributeGroupMutation.isPending}
      mode="delete"
      title={t('delete_customized_segments_group')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_confirmation', { target: customerAttributeGroup.name })}
    </ExecuteCancelDialog>
  )
}
